import { render, staticRenderFns } from "./LinkedFieldsTagsMenu.vue?vue&type=template&id=10356e3e&scoped=true&"
import script from "./LinkedFieldsTagsMenu.vue?vue&type=script&lang=js&"
export * from "./LinkedFieldsTagsMenu.vue?vue&type=script&lang=js&"
import style0 from "./LinkedFieldsTagsMenu.vue?vue&type=style&index=0&id=10356e3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10356e3e",
  null
  
)

export default component.exports